<i-feather [name]="name" [class]="'wh' + size" [ngClass]="iconClass"></i-feather>
